<template>
  <div class="section">
    <div class="container w-container">
      <div
        id="modal"
        class="modal absolute"
        v-if="
          tokenVerificationStatus === 0 ||
          (tokenVerificationStatus >= 200 && tokenVerificationStatus < 300)
        "
      >
        <div class="verifying-container">
          <div class="modal-content">
            <div class="loader-wrapper">
              <react-wrapper :component="loader" />
            </div>
          </div>
        </div>
      </div>
      <div id="modal" class="modal absolute" v-else-if="tokenVerificationStatus === 401">
        <div class="modal-header">
          <h5 class="modal-title" id="modalTitle">Oops!</h5>
          <p class="modal-message">The link we sent to your e-mail has expired.</p>
        </div>
        <div class="modal-content">
          <div slot="footer" class="modal-content-footer">
            <router-link class="button w-button" :to="{ name: 'login' }"
              >Send me another</router-link
            >
          </div>
        </div>
      </div>
      <div id="modal" class="modal absolute" v-else-if="tokenVerificationStatus === 403">
        <div class="modal-header">
          <h5 class="modal-title" id="modalTitle">Oops!</h5>
          <p class="modal-message">
            The link we sent to your e-mail must be used in the same browser in which it
            was generated.
          </p>
        </div>
        <div class="modal-content">
          <div slot="footer" class="modal-content-footer">
            <router-link class="button w-button" :to="{ name: 'login' }"
              >Send me another</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters, mapActions } from 'vuex'
import { Vue, Component, Watch } from 'vue-property-decorator'
import Loader from '@/react-components/components/lottie/loading-animation'
import { AxiosResponse } from 'axios'
import { getSubjectSummary } from '@/service/api'
import { SubjectSummaryResponse } from '../../../src/service/api/types'

@Component({
  computed: {
    ...mapGetters({
      isAuthenticated: 'user/isAuthenticated',
      tokenVerificationStatus: 'user/tokenVerificationStatus',
    }),
    loader() {
      return Loader
    },
  },
  methods: {
    ...mapActions({
      verifyToken: 'user/verifyToken',
    }),
  },
})
export default class VerifyTokenVue extends Vue {
  verifyToken!: (token: string) => Promise<AxiosResponse | undefined>
  public isAuthenticated!: any

  @Watch('isAuthenticated')
  redirectTrigger(data: any) {
    this.tryRedirect()
  }

  public tryRedirect() {
    let redirect: any = this.$route.query.redirect
    const queryFlow = this.$route.query.flow

    if (!redirect) redirect = '/'

    const token = this.$route.query.token as string
    const storageToken = localStorage.getItem('token')

    if (queryFlow === undefined) {
      getSubjectSummary(token ?? storageToken).then(
        (response: SubjectSummaryResponse | undefined) => {
          if (
            response !== undefined &&
            response?.journey?.flags?.hasSummaryPage &&
            redirect === '/' &&
            this.isAuthenticated
          ) {
            if (token || this.$route.query.to === '/summary') {
              /* 
                  If we're authenticated with a token from the URL (External link)
                  Or we've already authenticated with no token in the URL but are on the summary page
                  We want to stay on the summary page 
               */

              localStorage.setItem('hasSummaryPage', 'true')
              this.$router.replace('/summary')
            }
          } else {
            localStorage.setItem('hasSummaryPage', 'false')
          }
        },
      )
    }

    if (this.$route.query.src) {
      redirect = `${redirect}?src=${this.$route.query.src}`
    }

    if ((this as any).isAuthenticated) {
      if (this.$route.query.to !== '/summary') {
        // If user is already authenticated and navigating to the summary page we don't want to redirect them to the chatbot
        this.$router.replace(redirect)
      }
    }
  }

  async mounted() {
    if (this.isAuthenticated) {
      this.tryRedirect()
    }

    const queryToken = this.$route.query.token as string

    if (queryToken && !Array.isArray(queryToken)) {
      localStorage.setItem('token', queryToken)
    }

    const storageToken = localStorage.getItem('token')

    const response = await this.verifyToken(queryToken ?? storageToken)

    if (response && response.status === 401) {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>

<style lang="less" scoped>
.verifying-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}
</style>
